module.exports = __webpack_public_path__ + "img/logo.cbf8f6a7.png";